// extracted by mini-css-extract-plugin
export default {"products":"CarouselProducts_products__ISNaO","card_col":"CarouselProducts_card_col__OI86A"};